import { render, staticRenderFns } from "./SPRTickCross.vue?vue&type=template&id=0830cc91&scoped=true"
import script from "./SPRTickCross.vue?vue&type=script&lang=js"
export * from "./SPRTickCross.vue?vue&type=script&lang=js"
import style0 from "./SPRTickCross.vue?vue&type=style&index=0&id=0830cc91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830cc91",
  null
  
)

export default component.exports